<template>
<div style="display:flex;">
    <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab" @contextmenu.native.prevent="handleContextMenu" style="flex:1;width: calc(100% - 160px);margin-right: 10px;">
        <el-tab-pane
            :key="item.path"
            v-for="(item) in stateTabsList"
            :label="item.title"
            :name="item.path"
        >
        </el-tab-pane>
    </el-tabs>
    <el-dropdown style="line-height: 40px;width:150px;text-align: right;" @command="handleCommand">
        <span class="el-dropdown-link" style="margin-right: 10px;">
            <i class="el-icon-user"></i>
            {{nickName}}
            <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>退出</el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>
    
    <ul v-show="contextMenuVisible" class="context-menu" :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }">
        <li @click="closeCurrentTab">关闭当前</li>
        <li @click="closeOtherTabs">关闭其他</li>
        <li @click="closeAllTabs">关闭全部</li>
    </ul>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { MessageBox} from 'element-ui'
export default {
    props: {
        nickName: {
            type: String,
            required: true
        }
    },
    watch:{
        stateCurTabName(val){
            //直接赋值给本地data中的属性，就不会报错啦
            this.editableTabsValue = val
        }
    },
    computed: {
        ...mapState({ 
            stateTabsList: state => state.app.stateTabsList,
            stateCurTabName: state => state.app.stateCurTabName 
        })
    },
    data(){
        return{
            editableTabsValue: '/homeboard',
            contextMenuVisible: false,
            contextMenuX: 0,
            contextMenuY: 0,
            contextMenuItem: null
        }
    },
    methods: {
        handleContextMenu(event) {
            const target = event.target;
            const tabElement = target.closest('.el-tabs__item');
            if (tabElement) {
                const tabItems = Array.from(document.querySelectorAll('.el-tabs__item'));
                const tabIndex = tabItems.indexOf(tabElement);
                if (tabIndex !== -1 && this.stateTabsList[tabIndex]) {
                    this.contextMenuItem = this.stateTabsList[tabIndex];
                    this.contextMenuX = event.clientX;
                    this.contextMenuY = event.clientY;
                    this.contextMenuVisible = true;
                    document.addEventListener('click', this.hideContextMenu);
                }
            } else {
                this.contextMenuVisible = false;
            }
        },
        hideContextMenu() {
            this.contextMenuVisible = false;
            document.removeEventListener('click', this.hideContextMenu);
        },
        closeCurrentTab() {
            if (this.contextMenuItem) {
                this.removeTab(this.contextMenuItem.path);
            }
            this.hideContextMenu();
        },
        closeOtherTabs() {
            if (this.contextMenuItem) {
                const targetPath = this.contextMenuItem.path;
                const tabsToClose = this.stateTabsList.filter(tab => tab.path !== targetPath);
                tabsToClose.forEach(tab => {
                    this.removeTab(tab.path);
                });
            }
            this.hideContextMenu();
        },
        closeAllTabs() {
            const tabsToClose = [...this.stateTabsList];
            tabsToClose.forEach(tab => {
                this.removeTab(tab.path);
            });
            this.hideContextMenu();
        },
        // 关闭页签
        removeTab(targetName) {
            if(this.stateTabsList.length<=1){
                this.$message('至少保留一个页签打开');
                return;
            }
            let tabs = this.stateTabsList;
            let activeName = this.editableTabsValue;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.path === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.path;
                            if(this.editableTabsValue == targetName){
                                this.editableTabsValue = activeName;
                                this.$router.push(activeName);
                                this.$store.commit('app/setCurTabName', activeName)
                            }
                        }
                    }
                });
            }
            
            this.editableTabs = tabs.filter(tab => tab.path !== targetName);
            this.$store.commit('app/mutationCloseTab', targetName); // 删除标签和缓存
        },
        async clickTab(tab) {
            let tabName = tab.name;
            if(tab.name.indexOf("/")<0){
                tabName = "/"+tabName;
            }
            if (tabName == this.$route.path) {
                return;
            }
            if(this.$route.path.split("/")[1] == tab.name.split("/")[0]){
                this.$router.push(tabName.split("/")[2]);
            }
            else{
                this.$router.push(tabName);
            }
        },
        handleCommand(command) {
            this.logout();// 退出
        },
        // 退出登录
        async logout(){
            MessageBox.confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("login/logout");
                document.location.href = '/#/login';
            }).catch(()=>{
                
            });
        }
    },  
    created() {
        let path = this.$route.path;
        if(path!=""){
            let value = {
                path,
                icon:this.$route.meta.icon,
                title:this.$route.meta.title,
                name:this.$route.name
            }
            this.$store.commit('app/mutationSelectTabs', value);
            this.editableTabsValue = path;
            this.$store.commit('app/setCurTabName', this.editableTabsValue);
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.hideContextMenu);
    }
}
</script>

<style lang="scss" scope>
    .el-tabs--card>.el-tabs__header .el-tabs__nav {
        border: 0;
    }
    .el-tabs--card>.el-tabs__header {
        border-bottom: 0;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover {
        background: #E6EFF9;
        // height: 35px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        // margin-top: 5px;
    }

    .context-menu {
        position: fixed;
        background: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 5px 0;
        z-index: 9999;
        min-width: 120px;
        list-style: none;
        margin: 0;
    }

    .context-menu li {
        padding: 8px 16px;
        cursor: pointer;
        font-size: 14px;
        color: #606266;
        transition: all 0.3s;
    }

    .context-menu li:hover {
        background-color: #f5f7fa;
        color: #409eff;
    }
</style>